import script from "./ChatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessage.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=38971a10&lang=postcss"

const __exports__ = script;

export default __exports__